import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=32308fe4&scoped=true&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"
import style0 from "./advertising.vue?vue&type=style&index=0&id=32308fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32308fe4",
  null
  
)

export default component.exports